function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0H50V50H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M45.032,3.5c-2.757,0-5,2.243-5,5s2.243,5,5,5s5-2.243,5-5S47.789,3.5,45.032,3.5z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2.022,
  d: "M20 13L1 13M15 18L1 18M15 23L1 23M19 28L1 28"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M39.54,13.563c-0.702-1.306-2.45-3.93-2.493-3.986c-0.07-0.142-0.175-0.436-7.851-5.483C28.75,3.737,28.2,3.548,27.607,3.548c-0.168,0-0.337,0.015-0.477,0.039L16.747,4.704c-0.89,0.254-3.253,0.93-2.958,2.842c0.125,1.001,1.505,1.457,2.735,1.457c0.147,0,0.288-0.007,0.371-0.019l9.721-0.196l3.446,2.688l-7.755,5.419c-2.096,1.524-3.989,3.518-2.119,6.786l6.899,9.967c-2.489,0.031-9.126,0.127-10.619,0.293c-2.385,0.28-2.742,1.685-2.742,2.496c0,1.244,0.866,2.5,2.8,2.5h16.1c1.3,0,2.317-0.462,2.79-1.267c0.424-0.72,0.37-1.635-0.148-2.568c-0.713-1.336-5.769-9.068-6.975-10.95l10.276-6.531C40.092,16.653,40.444,15.17,39.54,13.563z"
});

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M19.829,40.938c-1.511,1.563-3.144,3.282-3.911,4.192c-1.366,1.595-1.582,3.146-0.552,4.298C15.82,49.832,16.296,50,16.781,50c1.091,0,2.226-0.851,3.248-1.77c1.109-0.979,4.883-4.729,7.447-7.293H19.829z"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M48.815,21.525c-0.476-0.528-1.234-0.561-2.037-0.596c-0.176-0.007-0.357-0.015-0.553-0.029l-5.566-0.278l-0.175-1.959c-0.252,0.231-0.532,0.449-0.844,0.647l-4.422,2.811l0.289,1.665c0.006,0.039,0.018,0.076,0.032,0.111c0.315,0.735,0.713,1.463,1.89,1.602c0.068-0.004,6.901-0.399,8.401-0.4c2.774-0.173,3.301-1.424,3.368-2.168C49.237,22.315,49.112,21.855,48.815,21.525z"
}));

function SvgExercise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExercise);
export default __webpack_public_path__ + "static/media/exercise.c55646f8.svg";
export { ForwardRef as ReactComponent };